import React, { Component } from 'react';
import FormSelect from '../_shared/forms/FormSelect';
import FormInputNumber from '../_shared/forms/FormInputNumber';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ReactDOM from 'react-dom';
import moment from 'moment';

class JobDetailsDropdowns extends Component {
    constructor(props) {
        super(props);

        this.state = {
            job_type: '',
            quantity: '',
            qtyDisabled: false,
            extrasOptions: [],
            extras: '',
            date_ready: null,
        };
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState(
            {
                [name]: value,
            },
            () => {
                this.handleDisabled();
                this.handleExtras();
            }
        );
    };

    handleDisabled = () => {
        let type = this.props.jobs.filter((job) => job.id == this.state.job_type)[0];
        this.setState({
            qtyDisabled: type.name.trim().endsWith('CY'),
        });
    };

    handleExtras = () => {
        this.setState({
            extrasOptions: this.state.job_type == '21' ? this.props.tyreTypes : this.props.extras,
        });
    };

    handleDateChange = (date) => {
        this.setState({ date_ready: date });
    };

    render() {
        return (
            <div>
                <div className="row">
                    <div className="form-group col-md-4">
                        <FormSelect
                            classes="form-control"
                            name="job_type"
                            options={this.props.jobs}
                            value={this.state.job_type}
                            handleChange={this.handleChange}
                            label="job type"
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <FormInputNumber
                            type="number"
                            label="Quantity"
                            name="quantity"
                            step="1"
                            min="1"
                            classes="form-control"
                            value={this.state.quantity}
                            handleChange={this.handleChange}
                            handleDisabled={this.state.qtyDisabled}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <FormSelect
                            classes="form-control"
                            name="extras"
                            options={this.state.extrasOptions}
                            value={this.state.extras}
                            handleChange={this.handleChange}
                            label="extras"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-4" style={{ paddingRight: '8px' }}>
                        <DatePicker
                            className="form-control"
                            placeholderText="Preferred Date..."
                            minDate={new Date()}
                            onChange={(date) => this.handleDateChange(date)}
                            value={this.state.date_ready}
                            selected={this.state.date_ready}
                            dateFormat="dd/MM/yyyy"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById('jobDetailsDropdowns')) {
    let element = document.getElementById('jobDetailsDropdowns');
    ReactDOM.render(
        <JobDetailsDropdowns
            jobs={JSON.parse(element.dataset.jobs)}
            extras={JSON.parse(element.dataset.extras)}
            tyreTypes={JSON.parse(element.dataset.tyre_types)}
        />,
        element
    );
}

export default JobDetailsDropdowns;
